import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { HPBListContainer } from "@/components/features/snack/HPB/list";

import { useGetParams } from "./hooks/use-get-params";

export const DesignHPBListPage = () => {
	const { hotelID } = useGetParams();

	return (
		<PageMeta title="ホームページビルダー" url={generatePath(PATHS.HOTEL.HPB.LIST, { hotelID })}>
			<HPBListContainer hotelID={hotelID} />
		</PageMeta>
	);
};

DesignHPBListPage.displayName = "DesignHPBListPage";
